import type { LearnerLibraryResponse } from '@/types/coaching'

/** Only the current enrollment's library defines which lessons can be selected by default. */
export function getCurrentCurriculumLessonIds(library: LearnerLibraryResponse | undefined): Set<number> {
  const lessonIds = new Set<number>()
  for (const curriculum of library?.tree ?? []) {
    for (const course of curriculum.courses) {
      for (const module of course.modules) {
        for (const lesson of module.lessons) lessonIds.add(lesson.lessonId)
      }
    }
  }
  return lessonIds
}
